module.exports = __webpack_public_path__ + "static/media/logout.16428886.svg";